import React, { useState } from 'react';
import { User, Lock, Bell, Shield, CreditCard } from 'lucide-react';
const AccountSettings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  return <div className="py-6" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-15">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-16">
          Account Settings
        </h1>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-17">
        <div className="py-6" data-id="element-18">
          <div className="lg:grid lg:grid-cols-12 lg:gap-x-5" data-id="element-19">
            <aside className="py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3" data-id="element-20">
              <nav className="space-y-1" data-id="element-21">
                <button onClick={() => setActiveTab('profile')} className={`${activeTab === 'profile' ? 'bg-gray-50 text-[#115800] hover:text-[#115800] hover:bg-white' : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'} group rounded-md px-3 py-2 flex items-center text-sm font-medium w-full text-left`} data-id="element-22">
                  <User className={`${activeTab === 'profile' ? 'text-[#289f77]' : 'text-gray-400 group-hover:text-gray-500'} flex-shrink-0 -ml-1 mr-3 h-6 w-6`} data-id="element-23" />
                  <span className="truncate" data-id="element-24">Profile Information</span>
                </button>
                <button onClick={() => setActiveTab('security')} className={`${activeTab === 'security' ? 'bg-gray-50 text-[#115800] hover:text-[#115800] hover:bg-white' : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'} group rounded-md px-3 py-2 flex items-center text-sm font-medium w-full text-left`} data-id="element-25">
                  <Lock className={`${activeTab === 'security' ? 'text-[#289f77]' : 'text-gray-400 group-hover:text-gray-500'} flex-shrink-0 -ml-1 mr-3 h-6 w-6`} data-id="element-26" />
                  <span className="truncate" data-id="element-27">Security</span>
                </button>
                <button onClick={() => setActiveTab('notifications')} className={`${activeTab === 'notifications' ? 'bg-gray-50 text-[#115800] hover:text-[#115800] hover:bg-white' : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'} group rounded-md px-3 py-2 flex items-center text-sm font-medium w-full text-left`} data-id="element-28">
                  <Bell className={`${activeTab === 'notifications' ? 'text-[#289f77]' : 'text-gray-400 group-hover:text-gray-500'} flex-shrink-0 -ml-1 mr-3 h-6 w-6`} data-id="element-29" />
                  <span className="truncate" data-id="element-30">Notifications</span>
                </button>
                <button onClick={() => setActiveTab('payment')} className={`${activeTab === 'payment' ? 'bg-gray-50 text-[#115800] hover:text-[#115800] hover:bg-white' : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'} group rounded-md px-3 py-2 flex items-center text-sm font-medium w-full text-left`} data-id="element-31">
                  <CreditCard className={`${activeTab === 'payment' ? 'text-[#289f77]' : 'text-gray-400 group-hover:text-gray-500'} flex-shrink-0 -ml-1 mr-3 h-6 w-6`} data-id="element-32" />
                  <span className="truncate" data-id="element-33">Payment Methods</span>
                </button>
                <button onClick={() => setActiveTab('verification')} className={`${activeTab === 'verification' ? 'bg-gray-50 text-[#115800] hover:text-[#115800] hover:bg-white' : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'} group rounded-md px-3 py-2 flex items-center text-sm font-medium w-full text-left`} data-id="element-34">
                  <Shield className={`${activeTab === 'verification' ? 'text-[#289f77]' : 'text-gray-400 group-hover:text-gray-500'} flex-shrink-0 -ml-1 mr-3 h-6 w-6`} data-id="element-35" />
                  <span className="truncate" data-id="element-36">KYC Verification</span>
                </button>
              </nav>
            </aside>
            <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-9" data-id="element-37">
              {/* Profile Information Tab */}
              {activeTab === 'profile' && <div className="shadow sm:rounded-md sm:overflow-hidden" data-id="element-38">
                  <div className="bg-white py-6 px-4 space-y-6 sm:p-6" data-id="element-39">
                    <div data-id="element-40">
                      <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-41">
                        Profile Information
                      </h3>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-42">
                        Update your personal information and contact details.
                      </p>
                    </div>
                    <div className="grid grid-cols-6 gap-6" data-id="element-43">
                      <div className="col-span-6 sm:col-span-3" data-id="element-44">
                        <label htmlFor="first-name" className="block text-sm font-medium text-gray-700" data-id="element-45">
                          First name
                        </label>
                        <input type="text" name="first-name" id="first-name" defaultValue="John" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-46" />
                      </div>
                      <div className="col-span-6 sm:col-span-3" data-id="element-47">
                        <label htmlFor="last-name" className="block text-sm font-medium text-gray-700" data-id="element-48">
                          Last name
                        </label>
                        <input type="text" name="last-name" id="last-name" defaultValue="Doe" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-49" />
                      </div>
                      <div className="col-span-6 sm:col-span-4" data-id="element-50">
                        <label htmlFor="email-address" className="block text-sm font-medium text-gray-700" data-id="element-51">
                          Email address
                        </label>
                        <input type="email" name="email-address" id="email-address" defaultValue="john.doe@example.com" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-52" />
                      </div>
                      <div className="col-span-6 sm:col-span-4" data-id="element-53">
                        <label htmlFor="phone-number" className="block text-sm font-medium text-gray-700" data-id="element-54">
                          Phone number
                        </label>
                        <input type="tel" name="phone-number" id="phone-number" defaultValue="+1 (555) 123-4567" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-55" />
                      </div>
                      <div className="col-span-6 sm:col-span-3" data-id="element-56">
                        <label htmlFor="country" className="block text-sm font-medium text-gray-700" data-id="element-57">
                          Country
                        </label>
                        <select id="country" name="country" className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-58">
                          <option data-id="element-59">United States</option>
                          <option data-id="element-60">United Kingdom</option>
                          <option data-id="element-61">Nigeria</option>
                          <option data-id="element-62">South Africa</option>
                          <option data-id="element-63">Ghana</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 text-right sm:px-6" data-id="element-64">
                    <button type="submit" className="bg-[#289f77] border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-[#115800] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" data-id="element-65">
                      Save
                    </button>
                  </div>
                </div>}
              {/* Security Tab */}
              {activeTab === 'security' && <div className="shadow sm:rounded-md sm:overflow-hidden" data-id="element-66">
                  <div className="bg-white py-6 px-4 space-y-6 sm:p-6" data-id="element-67">
                    <div data-id="element-68">
                      <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-69">
                        Security Settings
                      </h3>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-70">
                        Update your password and security preferences.
                      </p>
                    </div>
                    <div className="space-y-6" data-id="element-71">
                      <div data-id="element-72">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-73">
                          Change Password
                        </h4>
                        <div className="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-4" data-id="element-74">
                          <div className="sm:col-span-4" data-id="element-75">
                            <label htmlFor="current-password" className="block text-sm font-medium text-gray-700" data-id="element-76">
                              Current password
                            </label>
                            <input type="password" name="current-password" id="current-password" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-77" />
                          </div>
                          <div className="sm:col-span-4" data-id="element-78">
                            <label htmlFor="new-password" className="block text-sm font-medium text-gray-700" data-id="element-79">
                              New password
                            </label>
                            <input type="password" name="new-password" id="new-password" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-80" />
                          </div>
                          <div className="sm:col-span-4" data-id="element-81">
                            <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700" data-id="element-82">
                              Confirm new password
                            </label>
                            <input type="password" name="confirm-password" id="confirm-password" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-83" />
                          </div>
                        </div>
                        <div className="mt-4" data-id="element-84">
                          <button type="button" className="bg-[#289f77] border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-[#115800] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" data-id="element-85">
                            Update Password
                          </button>
                        </div>
                      </div>
                      <div className="pt-6 border-t border-gray-200" data-id="element-86">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-87">
                          Two-Factor Authentication
                        </h4>
                        <div className="mt-4" data-id="element-88">
                          <div className="flex items-start" data-id="element-89">
                            <div className="flex items-center h-5" data-id="element-90">
                              <input id="two-factor" name="two-factor" type="checkbox" className="focus:ring-[#289f77] h-4 w-4 text-[#289f77] border-gray-300 rounded" data-id="element-91" />
                            </div>
                            <div className="ml-3 text-sm" data-id="element-92">
                              <label htmlFor="two-factor" className="font-medium text-gray-700" data-id="element-93">
                                Enable two-factor authentication
                              </label>
                              <p className="text-gray-500" data-id="element-94">
                                Add an extra layer of security to your account
                                by requiring a verification code in addition to
                                your password.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pt-6 border-t border-gray-200" data-id="element-95">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-96">
                          Session Management
                        </h4>
                        <div className="mt-4" data-id="element-97">
                          <button type="button" className="text-sm font-medium text-red-600 hover:text-red-500" data-id="element-98">
                            Sign out all other sessions
                          </button>
                          <p className="mt-1 text-sm text-gray-500" data-id="element-99">
                            Sign out from all devices except this one.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Notifications Tab */}
              {activeTab === 'notifications' && <div className="shadow sm:rounded-md sm:overflow-hidden" data-id="element-100">
                  <div className="bg-white py-6 px-4 space-y-6 sm:p-6" data-id="element-101">
                    <div data-id="element-102">
                      <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-103">
                        Notification Settings
                      </h3>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-104">
                        Decide which communications you'd like to receive and
                        how.
                      </p>
                    </div>
                    <div className="space-y-6" data-id="element-105">
                      <fieldset data-id="element-106">
                        <legend className="text-base font-medium text-gray-900" data-id="element-107">
                          By Email
                        </legend>
                        <div className="mt-4 space-y-4" data-id="element-108">
                          <div className="flex items-start" data-id="element-109">
                            <div className="flex items-center h-5" data-id="element-110">
                              <input id="transactions" name="transactions" type="checkbox" defaultChecked className="focus:ring-[#289f77] h-4 w-4 text-[#289f77] border-gray-300 rounded" data-id="element-111" />
                            </div>
                            <div className="ml-3 text-sm" data-id="element-112">
                              <label htmlFor="transactions" className="font-medium text-gray-700" data-id="element-113">
                                Transactions
                              </label>
                              <p className="text-gray-500" data-id="element-114">
                                Get notified when a transaction is made in your
                                account.
                              </p>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-115">
                            <div className="flex items-center h-5" data-id="element-116">
                              <input id="security-alerts" name="security-alerts" type="checkbox" defaultChecked className="focus:ring-[#289f77] h-4 w-4 text-[#289f77] border-gray-300 rounded" data-id="element-117" />
                            </div>
                            <div className="ml-3 text-sm" data-id="element-118">
                              <label htmlFor="security-alerts" className="font-medium text-gray-700" data-id="element-119">
                                Security alerts
                              </label>
                              <p className="text-gray-500" data-id="element-120">
                                Get notified about security events like password
                                changes.
                              </p>
                            </div>
                          </div>
                          <div className="flex items-start" data-id="element-121">
                            <div className="flex items-center h-5" data-id="element-122">
                              <input id="promotions" name="promotions" type="checkbox" className="focus:ring-[#289f77] h-4 w-4 text-[#289f77] border-gray-300 rounded" data-id="element-123" />
                            </div>
                            <div className="ml-3 text-sm" data-id="element-124">
                              <label htmlFor="promotions" className="font-medium text-gray-700" data-id="element-125">
                                Promotions
                              </label>
                              <p className="text-gray-500" data-id="element-126">
                                Get notified about new features and special
                                offers.
                              </p>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset className="pt-6 border-t border-gray-200" data-id="element-127">
                        <legend className="text-base font-medium text-gray-900" data-id="element-128">
                          Push Notifications
                        </legend>
                        <p className="text-sm text-gray-500" data-id="element-129">
                          These are delivered via SMS to your mobile phone.
                        </p>
                        <div className="mt-4 space-y-4" data-id="element-130">
                          <div className="flex items-center" data-id="element-131">
                            <input id="push-everything" name="push-notifications" type="radio" className="focus:ring-[#289f77] h-4 w-4 text-[#289f77] border-gray-300" data-id="element-132" />
                            <label htmlFor="push-everything" className="ml-3 block text-sm font-medium text-gray-700" data-id="element-133">
                              Everything
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-134">
                            <input id="push-email" name="push-notifications" type="radio" defaultChecked className="focus:ring-[#289f77] h-4 w-4 text-[#289f77] border-gray-300" data-id="element-135" />
                            <label htmlFor="push-email" className="ml-3 block text-sm font-medium text-gray-700" data-id="element-136">
                              Same as email
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-137">
                            <input id="push-nothing" name="push-notifications" type="radio" className="focus:ring-[#289f77] h-4 w-4 text-[#289f77] border-gray-300" data-id="element-138" />
                            <label htmlFor="push-nothing" className="ml-3 block text-sm font-medium text-gray-700" data-id="element-139">
                              No push notifications
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 text-right sm:px-6" data-id="element-140">
                    <button type="submit" className="bg-[#289f77] border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-[#115800] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" data-id="element-141">
                      Save
                    </button>
                  </div>
                </div>}
              {/* Payment Methods Tab */}
              {activeTab === 'payment' && <div className="shadow sm:rounded-md sm:overflow-hidden" data-id="element-142">
                  <div className="bg-white py-6 px-4 space-y-6 sm:p-6" data-id="element-143">
                    <div data-id="element-144">
                      <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-145">
                        Payment Methods
                      </h3>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-146">
                        Add and manage your payment methods for funding your
                        wallets.
                      </p>
                    </div>
                    <div className="space-y-6" data-id="element-147">
                      <div className="border-b border-gray-200 pb-6" data-id="element-148">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-149">
                          Your Cards
                        </h4>
                        <div className="mt-4 space-y-4" data-id="element-150">
                          <div className="bg-gray-50 p-4 rounded-md flex justify-between items-center" data-id="element-151">
                            <div className="flex items-center" data-id="element-152">
                              <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-153">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-154">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" data-id="element-155" />
                                </svg>
                              </div>
                              <div className="ml-4" data-id="element-156">
                                <p className="text-sm font-medium text-gray-900" data-id="element-157">
                                  Visa ending in 4242
                                </p>
                                <p className="text-sm text-gray-500" data-id="element-158">
                                  Expires 12/2023
                                </p>
                              </div>
                            </div>
                            <div className="flex space-x-2" data-id="element-159">
                              <button type="button" className="text-sm font-medium text-[#289f77] hover:text-[#115800]" data-id="element-160">
                                Edit
                              </button>
                              <button type="button" className="text-sm font-medium text-red-600 hover:text-red-500" data-id="element-161">
                                Remove
                              </button>
                            </div>
                          </div>
                          <div className="bg-gray-50 p-4 rounded-md flex justify-between items-center" data-id="element-162">
                            <div className="flex items-center" data-id="element-163">
                              <div className="h-10 w-10 bg-red-100 rounded-full flex items-center justify-center" data-id="element-164">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-165">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" data-id="element-166" />
                                </svg>
                              </div>
                              <div className="ml-4" data-id="element-167">
                                <p className="text-sm font-medium text-gray-900" data-id="element-168">
                                  Mastercard ending in 5555
                                </p>
                                <p className="text-sm text-gray-500" data-id="element-169">
                                  Expires 08/2024
                                </p>
                              </div>
                            </div>
                            <div className="flex space-x-2" data-id="element-170">
                              <button type="button" className="text-sm font-medium text-[#289f77] hover:text-[#115800]" data-id="element-171">
                                Edit
                              </button>
                              <button type="button" className="text-sm font-medium text-red-600 hover:text-red-500" data-id="element-172">
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="mt-6" data-id="element-173">
                          <button type="button" className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" data-id="element-174">
                            <svg className="-ml-1 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-175">
                              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" data-id="element-176" />
                            </svg>
                            Add new card
                          </button>
                        </div>
                      </div>
                      <div data-id="element-177">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-178">
                          Bank Accounts
                        </h4>
                        <div className="mt-4 space-y-4" data-id="element-179">
                          <div className="bg-gray-50 p-4 rounded-md flex justify-between items-center" data-id="element-180">
                            <div className="flex items-center" data-id="element-181">
                              <div className="h-10 w-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-182">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-183">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" data-id="element-184" />
                                </svg>
                              </div>
                              <div className="ml-4" data-id="element-185">
                                <p className="text-sm font-medium text-gray-900" data-id="element-186">
                                  Chase Bank
                                </p>
                                <p className="text-sm text-gray-500" data-id="element-187">
                                  Account ending in 9876
                                </p>
                              </div>
                            </div>
                            <div className="flex space-x-2" data-id="element-188">
                              <button type="button" className="text-sm font-medium text-red-600 hover:text-red-500" data-id="element-189">
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="mt-6" data-id="element-190">
                          <button type="button" className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" data-id="element-191">
                            <svg className="-ml-1 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-192">
                              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" data-id="element-193" />
                            </svg>
                            Add bank account
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
              {/* KYC Verification Tab */}
              {activeTab === 'verification' && <div className="shadow sm:rounded-md sm:overflow-hidden" data-id="element-194">
                  <div className="bg-white py-6 px-4 space-y-6 sm:p-6" data-id="element-195">
                    <div data-id="element-196">
                      <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-197">
                        Identity Verification
                      </h3>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-198">
                        Complete your KYC verification to unlock all features of
                        your account.
                      </p>
                    </div>
                    <div className="space-y-6" data-id="element-199">
                      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4" data-id="element-200">
                        <div className="flex" data-id="element-201">
                          <div className="flex-shrink-0" data-id="element-202">
                            <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-203">
                              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-204" />
                            </svg>
                          </div>
                          <div className="ml-3" data-id="element-205">
                            <p className="text-sm text-yellow-700" data-id="element-206">
                              Your identity verification is pending. Please
                              complete the process to unlock all features.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-gray-200 pb-6" data-id="element-207">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-208">
                          Personal Information
                        </h4>
                        <div className="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-4" data-id="element-209">
                          <div className="sm:col-span-3" data-id="element-210">
                            <label htmlFor="verification-first-name" className="block text-sm font-medium text-gray-700" data-id="element-211">
                              First name
                            </label>
                            <input type="text" name="verification-first-name" id="verification-first-name" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-212" />
                          </div>
                          <div className="sm:col-span-3" data-id="element-213">
                            <label htmlFor="verification-last-name" className="block text-sm font-medium text-gray-700" data-id="element-214">
                              Last name
                            </label>
                            <input type="text" name="verification-last-name" id="verification-last-name" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-215" />
                          </div>
                          <div className="sm:col-span-4" data-id="element-216">
                            <label htmlFor="date-of-birth" className="block text-sm font-medium text-gray-700" data-id="element-217">
                              Date of birth
                            </label>
                            <input type="date" name="date-of-birth" id="date-of-birth" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-218" />
                          </div>
                          <div className="sm:col-span-6" data-id="element-219">
                            <label htmlFor="address" className="block text-sm font-medium text-gray-700" data-id="element-220">
                              Address
                            </label>
                            <input type="text" name="address" id="address" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-221" />
                          </div>
                          <div className="sm:col-span-2" data-id="element-222">
                            <label htmlFor="city" className="block text-sm font-medium text-gray-700" data-id="element-223">
                              City
                            </label>
                            <input type="text" name="city" id="city" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-224" />
                          </div>
                          <div className="sm:col-span-2" data-id="element-225">
                            <label htmlFor="state" className="block text-sm font-medium text-gray-700" data-id="element-226">
                              State / Province
                            </label>
                            <input type="text" name="state" id="state" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-227" />
                          </div>
                          <div className="sm:col-span-2" data-id="element-228">
                            <label htmlFor="postal-code" className="block text-sm font-medium text-gray-700" data-id="element-229">
                              ZIP / Postal code
                            </label>
                            <input type="text" name="postal-code" id="postal-code" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-230" />
                          </div>
                        </div>
                      </div>
                      <div data-id="element-231">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-232">
                          Identity Documents
                        </h4>
                        <p className="mt-1 text-sm text-gray-500" data-id="element-233">
                          Please upload a valid government-issued ID document.
                        </p>
                        <div className="mt-4 space-y-4" data-id="element-234">
                          <div data-id="element-235">
                            <label className="block text-sm font-medium text-gray-700" data-id="element-236">
                              ID Type
                            </label>
                            <select className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-237">
                              <option data-id="element-238">Passport</option>
                              <option data-id="element-239">Driver's License</option>
                              <option data-id="element-240">National ID Card</option>
                            </select>
                          </div>
                          <div data-id="element-241">
                            <label className="block text-sm font-medium text-gray-700" data-id="element-242">
                              Front of ID
                            </label>
                            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md" data-id="element-243">
                              <div className="space-y-1 text-center" data-id="element-244">
                                <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true" data-id="element-245">
                                  <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-246" />
                                </svg>
                                <div className="flex text-sm text-gray-600" data-id="element-247">
                                  <label htmlFor="file-upload-1" className="relative cursor-pointer bg-white rounded-md font-medium text-[#289f77] hover:text-[#115800] focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#289f77]" data-id="element-248">
                                    <span data-id="element-249">Upload a file</span>
                                    <input id="file-upload-1" name="file-upload-1" type="file" className="sr-only" data-id="element-250" />
                                  </label>
                                  <p className="pl-1" data-id="element-251">or drag and drop</p>
                                </div>
                                <p className="text-xs text-gray-500" data-id="element-252">
                                  PNG, JPG, GIF up to 10MB
                                </p>
                              </div>
                            </div>
                          </div>
                          <div data-id="element-253">
                            <label className="block text-sm font-medium text-gray-700" data-id="element-254">
                              Back of ID
                            </label>
                            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md" data-id="element-255">
                              <div className="space-y-1 text-center" data-id="element-256">
                                <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true" data-id="element-257">
                                  <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-258" />
                                </svg>
                                <div className="flex text-sm text-gray-600" data-id="element-259">
                                  <label htmlFor="file-upload-2" className="relative cursor-pointer bg-white rounded-md font-medium text-[#289f77] hover:text-[#115800] focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#289f77]" data-id="element-260">
                                    <span data-id="element-261">Upload a file</span>
                                    <input id="file-upload-2" name="file-upload-2" type="file" className="sr-only" data-id="element-262" />
                                  </label>
                                  <p className="pl-1" data-id="element-263">or drag and drop</p>
                                </div>
                                <p className="text-xs text-gray-500" data-id="element-264">
                                  PNG, JPG, GIF up to 10MB
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 text-right sm:px-6" data-id="element-265">
                    <button type="submit" className="bg-[#289f77] border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-[#115800] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" data-id="element-266">
                      Submit for Verification
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default AccountSettings;